import { GetData, GetDataV2 } from "./Functions/SettingData";

export const getRoles = async () => {
  const config = {
    method: "get",
    url: "/api/rbac/roles",
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const createRole = async (data) => {
  const config = {
    method: "post",
    url: "/api/rbac/roles",
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const updateRole = async (id, data) => {
  const config = {
    method: "put",
    url: `/api/rbac/roles/${id}`,
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const deleteRole = async (id) => {
  const config = {
    method: "delete",
    url: `/api/rbac/roles/${id}`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const duplicateRole = async (id) => {
  const config = {
    method: "post",
    url: `/api/rbac/roles/${id}/duplicate`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const getFeatures = async () => {
  const config = {
    method: "get",
    url: "/api/rbac/features",
    headers: { "Content-Type": "application/json" },
    params: { grouped: true },
  };
  return GetData(config);
};

export const getRolePermissions = async (id) => {
  const config = {
    method: "get",
    url: `/api/rbac/roles/${id}/permissions`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const updateRolePermissions = async (id, permissions) => {
  const config = {
    method: "put",
    url: `/api/rbac/roles/${id}/permissions`,
    headers: { "Content-Type": "application/json" },
    data: { permissions },
  };
  return GetData(config);
};

// params: { page, perPage, search?, roleCodes? }
// roleCodes is a comma-separated string of role codes (e.g. "ORG_ADMIN,DEPOT_INCHARGE").
export const getRbacUsers = async (params) => {
  const config = {
    method: "get",
    url: "/api/rbac/users",
    headers: { "Content-Type": "application/json" },
    params,
  };
  return GetData(config);
};

export const getUserRole = async (userId) => {
  const config = {
    method: "get",
    url: `/api/rbac/users/${userId}/role`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const updateUserRole = async (userId, data) => {
  const config = {
    method: "put",
    url: `/api/rbac/users/${userId}/role`,
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const getUserLocations = async (userId) => {
  const config = {
    method: "get",
    url: `/api/rbac/users/${userId}/locations`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const updateUserLocations = async (userId, data) => {
  const config = {
    method: "put",
    url: `/api/rbac/users/${userId}/locations`,
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const getUserFleets = async (userId) => {
  const config = {
    method: "get",
    url: `/api/rbac/users/${userId}/fleets`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const updateUserFleets = async (userId, data) => {
  const config = {
    method: "put",
    url: `/api/rbac/users/${userId}/fleets`,
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const getOrgLocationLevels = async () => {
  const config = {
    method: "get",
    url: "/api/rbac/org-location-levels",
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const getOrgLocationMaster = async (params) => {
  const config = {
    method: "get",
    url: "/api/rbac/org-location-master",
    headers: { "Content-Type": "application/json" },
    params,
  };
  return GetData(config);
};

export const createOrgLocationMaster = async (data) => {
  const config = {
    method: "post",
    url: "/api/rbac/org-location-master",
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const updateOrgLocationMaster = async (id, data) => {
  const config = {
    method: "put",
    url: `/api/rbac/org-location-master/${id}`,
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetData(config);
};

export const deleteOrgLocationMaster = async (id) => {
  const config = {
    method: "delete",
    url: `/api/rbac/org-location-master/${id}`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const getAuditLogs = async (params) => {
  const config = {
    method: "get",
    url: "/api/rbac/audit-logs",
    headers: { "Content-Type": "application/json" },
    params,
  };
  return GetData(config);
};

export const forceLogoutUser = async (userId) => {
  const config = {
    method: "post",
    url: `/api/rbac/users/${userId}/force-logout`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const forceLogoutAllUsers = async () => {
  const config = {
    method: "post",
    url: `/api/rbac/users/all/force-logout`,
    headers: { "Content-Type": "application/json" },
  };
  return GetData(config);
};

export const createUser = async (data) => {
  const config = {
    method: "post",
    url: "/api/v1/users",
    headers: { "Content-Type": "application/json" },
    data,
  };
  return GetDataV2(config);
};

// Set a single user's subscription plan ("paid" | "free").
export const updateUserSubscriptionPlan = async (userId, plan) => {
  const config = {
    method: "put",
    url: `/api/rbac/users/${userId}/subscription-plan`,
    headers: { "Content-Type": "application/json" },
    data: { plan },
  };
  return GetData(config);
};

// Set the subscription plan for one or more users at once.
export const bulkUpdateUserSubscriptionPlan = async (userIds, plan) => {
  const config = {
    method: "put",
    url: `/api/rbac/users/subscription-plan`,
    headers: { "Content-Type": "application/json" },
    data: { userIds, plan },
  };
  return GetData(config);
};
